import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {FormsModule} from "@angular/forms";

import {AbstractStyleComponent} from '../abstract-style/abstract-style.component';
import {FontFamilyService} from '../../../../../../services/cms/font-family.service';

@Component({
  selector: 'app-font',
  imports: [
    FormsModule
],
  templateUrl: './font.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './font.component.scss'
})
export class FontComponent extends AbstractStyleComponent implements OnInit {
  protected fonts: any = [];

  protected styles: any = [
    {value: null, label: 'Normal'},
    {value: 'italic', label: 'Italic'},
  ];

  family: string | null = null;
  size: number | null = null;
  style: string | null = null;
  weight: number | null = null;

  constructor(private fontFamilyService: FontFamilyService) {
    super();
  }

  ngOnInit(): void {
    this.fontFamilyService.getFonts().subscribe((fonts: string[]) => {
      this.fonts = [{value: null, label: 'Default'}];

      for (const font of fonts) {
        this.fonts.push({
          value: font,
          label: font,
        });
      }

      this.fonts.sort((a: any, b: any) => a.label.localeCompare(b.label, 'fr'));
    });
  }

  getValue(): any {
    return {
      family: this.family,
      size: this.formatPixelValue(this.size),
      weight: this.weight,
      style: this.style
    };
  }

  setValue(value: any): void {
    this.family = value.family;
    this.style = value.style;
    this.size = this.parseNumberValue(value['size']);
    this.weight = this.parseNumberValue(value['weight']);
  }

  checkSize(): void {
    if (this.size !== null && this.size < 1) {
      this.size = 10;
    }
  }

  checkWeight(): void {
    if (this.weight !== null) {
      if (this.weight < 100) {
        this.weight = 100;
      }
      if (this.weight > 900) {
        this.weight = 900;
      }
    }
  }
}
